"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupHisaiSearchReducer = exports.groupHisaiSearchActions = exports.TYPES = exports.INIT_STATE = exports.CONTENTS = void 0;
var _dateUtil = _interopRequireDefault(require("01_core/logics/dateUtil"));
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// アクションタイプの接頭辞
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'Search';

// 表示コンテンツ
const CONTENTS = exports.CONTENTS = {
  MAIN: 'main',
  // 検索
  UPDATE_INFO: 'update_info',
  //更新
  RESULT: 'result',
  HISTORY: 'history',
  // 履歴
  DETAIL: 'detail',
  // 詳細
  DELETE: 'delete',
  // 削除
  HOME: 'home',
  // ホーム
  MENU: 'menu' // メニュー
};

// 初期状態
const INIT_STATE = exports.INIT_STATE = {
  containerInfo: {
    dispContet: CONTENTS.MAIN,
    previousContent: CONTENTS.MENU,
    entranceContent: CONTENTS.MENU
  },
  selectDisaster: {
    disasterNo: '',
    disasterNm: '',
    disasterDt: '',
    trainingFlg: '',
    dtl: []
  },
  searchConditions: {
    srhStartDt: '',
    hisaiKbnCd: []
  },
  main: {
    searchResult: [],
    scrollTop: {
      index: 0,
      scrollY: 0,
      noSticky: false
    },
    paging: {
      viewNum: 50,
      currentPage: 0
    }
  },
  history: {
    grouphisaiHistory: [],
    scrollTop: {
      index: 0,
      scrollY: 0,
      noSticky: false
    },
    paging: {
      viewNum: 50,
      currentPage: 0
    },
    selectHisaiKbnCd: '',
    selectSeq: '',
    hisaiKbnName: ''
  },
  entries: {
    content: ''
  },
  initDisasterComplete: false,
  // 再検索用フラグ
  search: false
};

// アクションタイプ
const TYPES = exports.TYPES = {
  // 災害情報選択初期表示
  INIT_DISASTER: PREFIX + 'DisasterInit',
  // 災害情報選択変更
  CHANGE_DISASTER: PREFIX + 'ChangeDisaster',
  // 検索条件変更
  CHANGE_SEARCH_CONDITION: PREFIX + 'ChangeSearchCondtion',
  // 検索結果一覧設定
  SET_SEARCH_RESULT: PREFIX + 'SetSearchResult',
  // 履歴情報の設定
  SET_GROUPHISAI_HISTORY: PREFIX + 'SetGrouphisaiHistory',
  // スクロール変更
  CHANGE_SCROLL_TOP: PREFIX + 'ChangeScrollTop',
  // ページ変更
  CHANGE_PAGE: PREFIX + 'ChangePage',
  // １ページの表示件数を変更
  CHANGE_VIEW_NUM: PREFIX + 'ChangeViewNum',
  // 遷移元の設定
  SET_ENTRANCE_CONTENT: PREFIX + 'SetEntranceContent',
  // NECグループ被災情報更新画面遷移
  GO_UPDATE: PREFIX + 'GoUpdate',
  // NECグループ被災情報履歴画面遷移
  GO_HISTORY: PREFIX + 'GoHistory',
  // NECグループ被災情報詳細画面遷移
  GO_DETAIL: PREFIX + 'GoDetail',
  // NECグループ被災情報削除画面遷移
  GO_DELETE: PREFIX + 'GoDelete',
  // 再検索フラグ更新
  SET_SEARCH_FLG: PREFIX + 'SetSearchFlg',
  // NECグループ被災情報検索画面遷移
  GO_MAIN: PREFIX + 'GoMain',
  // 初期状態にする
  CLEAR: PREFIX + 'Clear',
  // 更新画面項目設定
  SET_ENTRY: PREFIX + 'SetEntry',
  // NECグループ被災情報取得設定
  SET_ENTRIES: PREFIX + 'SetEntries',
  // 更新画面項目変更
  CHANGE_ENTRIES: PREFIX + 'ChangeEntries',
  // コンテンツ設定
  SET_CONTENT: PREFIX + 'SetContent'
};
const groupHisaiSearchActions = exports.groupHisaiSearchActions = (0, _reduxActions.createActions)({
  // 災害情報選択初期表示
  [TYPES.INIT_DISASTER]: function () {
    return {
      selectDisaster: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // 災害情報選択変更
  [TYPES.CHANGE_DISASTER]: function () {
    return {
      selectDisaster: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // 検索条件変更
  [TYPES.CHANGE_SEARCH_CONDITION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // 検索結果一覧設定
  [TYPES.SET_SEARCH_RESULT]: function () {
    return {
      searchResult: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // 履歴情報の設定
  [TYPES.SET_GROUPHISAI_HISTORY]: function () {
    return {
      grouphisaiHistory: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // スクロール位置を変更
  [TYPES.CHANGE_SCROLL_TOP]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      scrollTop: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // ページ変更
  [TYPES.CHANGE_PAGE]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      currentPage: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // １ページの表示件数を変更
  [TYPES.CHANGE_VIEW_NUM]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      viewNum: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // 遷移元の設定
  [TYPES.SET_ENTRANCE_CONTENT]: function () {
    return {
      entranceContent: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // NECグループ被災情報履歴画面遷移
  [TYPES.GO_HISTORY]: function () {
    return {
      selectHisaiKbnCd: arguments.length <= 0 ? undefined : arguments[0],
      hisaiKbnName: arguments.length <= 1 ? undefined : arguments[1],
      previousContent: arguments.length <= 2 ? undefined : arguments[2]
    };
  },
  // NECグループ被災情報詳細画面遷移
  [TYPES.GO_DETAIL]: function () {
    return {
      selectSeq: arguments.length <= 0 ? undefined : arguments[0],
      previousContent: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // NECグループ被災情報削除画面遷移
  [TYPES.GO_DELETE]: function () {
    return {
      selectSeq: arguments.length <= 0 ? undefined : arguments[0],
      previousContent: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // NECグループ被災情報検索画面遷移
  [TYPES.GO_MAIN]: function () {
    return {
      previousContent: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // NECグループ被災情報更新画面遷移
  [TYPES.GO_UPDATE]: function () {
    return {
      selectSeq: arguments.length <= 0 ? undefined : arguments[0],
      previousContent: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // 更新画面項目設定
  [TYPES.SET_ENTRY]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // NECグループ被災情報取得設定
  [TYPES.SET_ENTRIES]: function () {
    return {
      entries: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // 更新画面項目変更
  [TYPES.CHANGE_ENTRIES]: function () {
    return {
      content: arguments.length <= 0 ? undefined : arguments[0],
      lastUpdNm: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // コンテンツ設定
  [TYPES.SET_CONTENT]: function () {
    return {
      content: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
},
// 再検索フラグ更新
TYPES.SET_SEARCH_FLG,
// 初期状態にする
TYPES.CLEAR);
let initStartDt = null;
const groupHisaiSearchReducer = exports.groupHisaiSearchReducer = (0, _reduxActions.handleActions)({
  // 災害情報選択初期表示
  [TYPES.INIT_DISASTER]: (state, action) => {
    const selectDisaster = action.payload.selectDisaster;
    if (state.initDisasterComplete) {
      return _objectSpread({}, state);
    }
    if (selectDisaster) {
      initStartDt = null;
      return _objectSpread(_objectSpread({}, state), {}, {
        searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
          srhStartDt: selectDisaster.disasterDt
        }),
        selectDisaster: selectDisaster,
        initDisasterComplete: true
      });
    } else {
      initStartDt = _dateUtil.default.getDateTimeBeforeMonth();
      return _objectSpread(_objectSpread({}, state), {}, {
        searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
          srhStartDt: initStartDt
        }),
        initDisasterComplete: true
      });
    }
  },
  // 災害情報選択変更
  [TYPES.CHANGE_DISASTER]: (state, action) => {
    const {
      selectDisaster
    } = action.payload;
    if (selectDisaster) {
      return _objectSpread(_objectSpread({}, state), {}, {
        searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
          tdfkCd: selectDisaster.dtl.map(element => element.tdfkCd),
          srhStartDt: selectDisaster.disasterDt
        }),
        selectDisaster: selectDisaster
      });
    } else {
      return _objectSpread(_objectSpread({}, state), {}, {
        searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
          srhStartDt: ''
        }),
        selectDisaster: _objectSpread({}, INIT_STATE.selectDisaster)
      });
    }
  },
  // 検索条件変更
  [TYPES.CHANGE_SEARCH_CONDITION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
      [action.payload.key]: action.payload.value
    })
  }),
  // 検索結果一覧設定
  [TYPES.SET_SEARCH_RESULT]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    main: _objectSpread(_objectSpread({}, state.main), {}, {
      searchResult: action.payload.searchResult,
      paging: INIT_STATE.main.paging
    }),
    search: false
  }),
  // 履歴情報の設定
  [TYPES.SET_GROUPHISAI_HISTORY]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    history: _objectSpread(_objectSpread({}, state.history), {}, {
      grouphisaiHistory: action.payload.grouphisaiHistory
    })
  }),
  // スクロール変更
  [TYPES.CHANGE_SCROLL_TOP]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      [action.payload.key]: _objectSpread(_objectSpread({}, state[action.payload.key]), {}, {
        scrollTop: action.payload.scrollTop
      })
    });
  },
  // ページ変更
  [TYPES.CHANGE_PAGE]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      [action.payload.key]: _objectSpread(_objectSpread({}, state[action.payload.key]), {}, {
        paging: _objectSpread(_objectSpread({}, state[action.payload.key].paging), {}, {
          currentPage: action.payload.currentPage
        })
      })
    });
  },
  // １ページの表示件数を変更
  [TYPES.CHANGE_VIEW_NUM]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      [action.payload.key]: _objectSpread(_objectSpread({}, state[action.payload.key]), {}, {
        paging: _objectSpread(_objectSpread({}, state[action.payload.key].paging), {}, {
          currentPage: 0,
          viewNum: action.payload.viewNum
        })
      })
    });
  },
  // 遷移元の設定
  [TYPES.SET_ENTRANCE_CONTENT]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      containerInfo: _objectSpread(_objectSpread({}, state.containerInfo), {}, {
        entranceContent: action.payload.entranceContent
      })
    });
  },
  // NECグループ被災情報履歴画面遷移
  [TYPES.GO_HISTORY]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    selectHisaiKbnCd: action.payload.selectHisaiKbnCd,
    hisaiKbnName: action.payload.hisaiKbnName,
    containerInfo: _objectSpread(_objectSpread({}, state.containerInfo), {}, {
      dispContet: CONTENTS.HISTORY,
      previousContent: action.payload.previousContent
    }),
    history: _objectSpread(_objectSpread({}, state.history), {}, {
      scrollTop: action.payload.previousContent === CONTENTS.MAIN ? _objectSpread({}, INIT_STATE.history.scrollTop) : state.history.scrollTop
    })
  }),
  // NECグループ被災情報詳細画面遷移
  [TYPES.GO_DETAIL]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    selectSeq: action.payload.selectSeq,
    containerInfo: _objectSpread(_objectSpread({}, state.containerInfo), {}, {
      dispContet: CONTENTS.DETAIL,
      previousContent: action.payload.previousContent
    })
  }),
  // NECグループ被災情報削除画面遷移
  [TYPES.GO_DELETE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    selectSeq: action.payload.selectSeq,
    // previousView: action.payload.previousView,
    containerInfo: _objectSpread(_objectSpread({}, state.containerInfo), {}, {
      dispContet: CONTENTS.DELETE,
      previousContent: action.payload.previousContent
    })
  }),
  // NECグループ被災情報更新画面遷移
  [TYPES.GO_UPDATE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    selectSeq: action.payload.selectSeq,
    containerInfo: _objectSpread(_objectSpread({}, state.containerInfo), {}, {
      dispContet: CONTENTS.UPDATE_INFO,
      previousContent: action.payload.previousContent
    })
  }),
  // 更新画面項目設定
  [TYPES.SET_ENTRY]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        [action.payload.key]: action.payload.value
      })
    });
  },
  // NECグループ被災情報取得設定
  [TYPES.SET_ENTRIES]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: action.payload.entries
    });
  },
  // 更新画面項目変更
  [TYPES.CHANGE_ENTRIES]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        content: action.payload.content,
        lastUpdNm: action.payload.lastUpdNm
      })
    });
  },
  // コンテンツ設定
  [TYPES.SET_CONTENT]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: action.payload.content
    });
  },
  // 再検索フラグ更新
  [TYPES.SET_SEARCH_FLG]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      // 再検索用フラグ（履歴一覧・検索結果一覧を再描画する）
      search: true
    });
  },
  // NECグループ被災情報検索画面遷移
  [TYPES.GO_MAIN]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    containerInfo: _objectSpread(_objectSpread({}, state.containerInfo), {}, {
      dispContet: CONTENTS.MAIN,
      previousContent: action.payload.previousContent
    })
  }),
  // 初期状態にする
  [TYPES.CLEAR]: (state, action) => _objectSpread({}, INIT_STATE)
}, INIT_STATE);